export const IDENTITY_KEYS = {
    all: ['identity'] as const,

    session: () => [...IDENTITY_KEYS.all, 'session'] as const,

    usuarios: () => [...IDENTITY_KEYS.all, 'usuarios'] as const,
    usuario: (id: number) => [...IDENTITY_KEYS.usuarios(), id] as const,

    roles: () => [...IDENTITY_KEYS.all, 'roles'] as const,
    rol: (id: number) => [...IDENTITY_KEYS.roles(), id] as const,
    password: () => [...IDENTITY_KEYS.all, 'password'] as const,
};
